<template>
  <div class="visor">
    <visor-pedidos :modo="modo" />
  </div>
</template>

<script>
import VisorPedidos from '@/components/visor/VisorPedidos.vue'

export default {
  name: 'Visor',
  components: {
    VisorPedidos
  },
  props: {
    modo: {
      type: String,
      required: true
    }
  }
}
</script>
